/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_ItemsInputs */

const en_orders_items = /** @type {(inputs: Orders_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const es_orders_items = /** @type {(inputs: Orders_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articulos`)
};

/**
* | output |
* | --- |
* | "Items" |
*
* @param {Orders_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_items = /** @type {((inputs?: Orders_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_items(inputs)
	return es_orders_items(inputs)
});